import { Good } from "../../../../assets";
import { Button, PageHeader } from "../../../../components";
import { useHistory } from "react-router-dom";
import {
  paymentWrapper,
  paymentMainWrapper,
} from "./paymentSuccess.module.css";

const PaymentSuccess = () => {
  const history = useHistory();
  const handleReturn = () => {
    history.push("/");
  };
  return (
    <div className={paymentWrapper}>
      <div className={paymentMainWrapper}>
        <img src={Good} width={100} height={100} />
        <PageHeader
          head="Payment Successful"
          text="Your tech journey begins here! Please check your email for more details."
        />
        <Button
          main="fill"
          buttonName="Return Home"
          //   className={learningPathButtonElement}
          onClick={handleReturn}
          //   icon={<RightIcon />}
        />
      </div>
    </div>
  );
};

export default PaymentSuccess;
